export default [
  {
    text: "Home",
    path: "/home",
    icon: "home" 
  }, 
  {
    text: 'Installation Info',
    path: '/site-detail',
    icon: 'map',
    authCode: 1,
  },
  {
    text: 'Realtime Monitor',
    path: '/realtime',
    icon: 'video',
    authCode: 1,
  },
  {
    text: 'Data Explorer',
    path: '/dashboard',
    icon: 'box',
    authCode: 1,
  },
  // {
  //   text: 'Advanced Analysis',
  //   path: '/advanced-analysis',
  //   icon: 'chart',
  //   authCode: 1
  // },
  /*{
    text: "My Account",
    path: "/profile",
    icon: "user",
    authCode: 1,
  },*/
  {
    text: 'Settings',
    path: '/settings',
    icon: 'preferences',
    authCode: 1
  }
  /*, 
  {
    text: 'Algorithms',
    icon: 'datausage',
    authCode: 1,
    items:[{
      text: 'EOD',
      path:'/algorithms-eod'
    }]
  }*/

];
